import axiosInstance from "./axiosInstance.ts";

const FilesService = {
    fetchFiles: (dataset_id: number, skip = 0, limit = 10, page = 1) =>
    axiosInstance.get(`/api/v1/datasets/${dataset_id}/files`, {
      params: {
        // dataset_id,
        skip,
        limit,
        page,
      },
      headers: {
        Accept: "application/json",
      },
    }),

    fetchNullAnalysis: (file_id: number) =>
    axiosInstance.get(`/api/v1/files/${file_id}/null-analysis`, {
      headers: {
        Accept: "application/json",
      },
    }),

  handlePreProcess: (file_id: number, config) =>
    axiosInstance.post(`/api/v1/files/${file_id}/preprocess-nulls`, config,  {
      headers: {
        Accept: "application/json",
      },
    }),

    fetchValidFiles: () =>
      axiosInstance.get("/api/v1/datasets/list-validated", {
        params: {
          skip: 0,
          limit: 100,
        },
        headers: {
          Accept: "application/json",
        },
      }),
  
    deleteFiles: (file_id: number) =>
    axiosInstance.delete(`${"/api/v1/files"}/${file_id}`),
    
    DownloadError: (filePath: string) =>
    axiosInstance.get(`api/v1/files/download/?file_path=${filePath}`, {
      headers: {
        Accept: "application/json",
      },
    }),

    fetchFileView: (file_id: number) =>
    axiosInstance.get(`/api/v1/files/${file_id}/view`, {
      // params: {
      //   file_id,
      // },
      headers: {
        Accept: "application/json",
      },
    }),
    addFiles: (dataset_id: number, formData: FormData) =>
  axiosInstance.post(`/api/v1/files/${dataset_id}`, formData, {
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  }),
};

export default FilesService;